import React from 'react';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import BaseDialog from '../BaseDialog';

const PointRow = ({ label, before, after }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.5 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {before} pt → {after} pt
    </Typography>
  </Stack>
);

const ReviveRoomPointDialog = ({
  isVisible,
  onClose,
  onConfirm,
  loading,
  canRevive,
  preview,
  result,
  errorMessage,
}) => {
  const current = result ?? preview ?? {};
  const movedPoints = current.moved_points ?? 0;
  const beforeTicket = current.before_ticket ?? 0;
  const afterTicket = current.ticket ?? beforeTicket;
  const beforeRoomPoint = current.before_room_point ?? 0;
  const afterRoomPoint = current.room_point ?? beforeRoomPoint;
  const reviveCount = current.revive_count ?? preview?.revive_count ?? 0;
  const remainingRevives = current.remaining_revives ?? preview?.remaining_revives ?? 0;

  return (
    <BaseDialog isVisible={isVisible} onClose={onClose}>
      <Box sx={{ p: { xs: 1.5, sm: 2 }, minWidth: { xs: 320, sm: 420 } }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          ルームチップ復活
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          参加チケットから不足分をルームチップへ移します。最低ベット可能な状態に復活します。
        </Typography>

        <Stack spacing={0.75} sx={{ mb: 2 }}>
          <Typography variant="body2">ルール</Typography>
          <Typography variant="body2" color="text.secondary">
            1ラウンドにつき1回まで
          </Typography>
          <Typography variant="body2" color="text.secondary">
            1イベントにつき最大3回まで
          </Typography>
          <Typography variant="body2" color="text.secondary">
            復活できるのは最低ベットに必要な不足分のみ
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ルームチップが最低ベットに不足している時だけ復活可能
          </Typography>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={0.5} sx={{ mb: 1.5 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            ポイント変化
          </Typography>
          <Typography variant="body2" color="text.secondary">
            移動: {movedPoints} pt
          </Typography>
          <PointRow label="参加チケット" before={beforeTicket} after={afterTicket} />
          <PointRow label="ルームチップ" before={beforeRoomPoint} after={afterRoomPoint} />
        </Stack>

        <Stack spacing={0.5} sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary">
            復活回数: {reviveCount} / 3
          </Typography>
          <Typography variant="body2" color="text.secondary">
            残り復活回数: {remainingRevives}
          </Typography>
        </Stack>

        {errorMessage ? (
          <Typography variant="body2" sx={{ color: '#b42318', mb: 2 }}>
            {errorMessage}
          </Typography>
        ) : null}

        {result ? (
          <Typography variant="body2" sx={{ color: '#027a48', mb: 2 }}>
            ルームチップを復活しました。
          </Typography>
        ) : null}

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="outlined" onClick={onClose}>
            閉じる
          </Button>
          {!result && (
            <Button variant="contained" onClick={onConfirm} disabled={!canRevive || loading}>
              {loading ? '復活中...' : '復活する'}
            </Button>
          )}
        </Stack>
      </Box>
    </BaseDialog>
  );
};

export default ReviveRoomPointDialog;
